(function () {
  'use strict';

  angular.module('app').component('clientContactDetail', clientContactDetail());

  function clientContactDetail() {
    return {
      bindings: {
        item: '=',
        client: '=',
        mode: '<',
        fast: '<',
        onClientContactSaved: '&',
        onClientContactCanceled: '&',
      },
      controller: ClientContactDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/clients/client-contacts/client-contact-detail/client-contact-detail.component.html',
    };
  }

  ClientContactDetailComponent.$inject = ['UtilService', 'ClientContactService'];

  function ClientContactDetailComponent(UtilService, ClientContactService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = [
      'name',
      'last_name',
      'position',
      'email',
      'phone_number',
      'phone_extension',
      'mobile_number',
    ];

    // Methods
    vm.editClientContact = editClientContact;
    vm.saveClientContact = saveClientContact;
    vm.cancel = cancel;

    vm.$onInit = function () {
      // vm.showFormField = true;
      // if (vm.fast) {
      //     vm.showFormField = false;
      // }

      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        vm.createMode = true;
      }
    };

    function setItemOptions(item, mode) {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editClientContact();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    function editClientContact() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    // Create/Update
    function saveClientContact(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      // !vm.UtilService.areEquivalentObjs(vm.item, itemCopy)
      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        ClientContactService.saveClientContact(vm.item, vm.client.id).then(function (data) {
          var status = data.status;
          var response = data.response;

          if (status) {
            // Success
            vm.onClientContactSaved({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      } else {
        cancel();
      }
    }

    function cancel() {
      vm.onClientContactCanceled();
    }
  }
})();
